import React from 'react'
import PropTypes from 'prop-types'
import RightPanel from '../../../RightPanel'
import { useGetSyncedTransactionById } from '../../../../../api/coreData'
import TransactionDetailView from './TransactionDetailView'

export default function TransactionDetailDrawer ({ open, onClose, transactionId }) {
  const { data: result, isLoading } = useGetSyncedTransactionById(transactionId, {
    enabled: open && !!transactionId
  })

  return (
    <RightPanel
      open={open}
      toggleOpen={onClose}
      title='Transaction Detail'
      showCloseButton
      width='640px'
      height='100vh'
    >
      <TransactionDetailView
        data={result?.data}
        displayMeta={result?.displayMeta}
        isLoading={isLoading}
        layout='narrow'
      />
    </RightPanel>
  )
}

TransactionDetailDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  transactionId: PropTypes.number
}
